import { Tag as TagAntd } from 'antd';
import cn from 'classnames';
import type { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './tag.module.css';

export type TagProperties = {
  rounded?: boolean;
  size?: 'large';
} & ComponentProps<typeof TagAntd>;

const Tag = ({ children, className, rounded, size, ...rest }: TagProperties) => {
  const { t } = useTranslation();

  return (
    <TagAntd
      className={cn(className, styles.tag, {
        [styles['tag--rounded'] ?? '']: rounded,
        [styles['tag--size-large'] ?? '']: size === 'large',
      })}
      {...rest}
    >
      {typeof children === 'string' ? t(children) : children}
    </TagAntd>
  );
};

export default Tag;
